var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.baseCss, _vm.block ? 'block' : ['inline-block', 'align-middle']]},[(_vm.outputMode === 'canvas')?_c('canvas'):_c('div',{domProps:{"innerHTML":_vm._s(_vm.output)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2514b585","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/bcq-ui/components/qr-code/qr-code.vue
// module id = null
// module chunks = 